var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalZakaut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 26.4 21.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient-6);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient-7);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: url(#linear-gradient-8);\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -37.7,
    y1: 63.7,
    x2: -36.6,
    y2: 62.9,
    gradientTransform: "translate(413.8 792.9) scale(11 -12.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59ac55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01a0ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -36,
    y1: 64.3,
    x2: -35,
    y2: 63.6,
    gradientTransform: "translate(280 997.9) scale(7.6 -15.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59ac55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01a0ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -37.6,
    y1: 63.7,
    x2: -36.6,
    y2: 63,
    gradientTransform: "translate(420.5 792.9) scale(11 -12.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59ac55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01a0ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -34.5,
    y1: 63.1,
    x2: -33.5,
    y2: 62.3,
    gradientTransform: "translate(211.2 685.1) scale(5.9 -10.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59ac55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01a0ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -34.4,
    y1: 63.2,
    x2: -33.4,
    y2: 62.4,
    gradientTransform: "translate(212.8 685.1) scale(5.9 -10.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59ac55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01a0ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -31.7,
    y1: 63.3,
    x2: -30.7,
    y2: 62.5,
    gradientTransform: "translate(143.8 710.9) scale(4.2 -11.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59ac55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01a0ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -38.2,
    y1: 62.6,
    x2: -37.2,
    y2: 61.8,
    gradientTransform: "translate(505.3 600.7) scale(13 -9.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59ac55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01a0ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -38.2,
    y1: 62.7,
    x2: -37.1,
    y2: 61.9,
    gradientTransform: "translate(492.3 600.7) scale(13 -9.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59ac55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01a0ea"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_797",
    "data-name": "Group 797"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "cls-1",
    d: "M14.5,15.7c-1.8,1.5-5.2-.2-7.9-3.5S4.4,3.8,4.4,3.8c0,0,5.2.2,7.9,3.5,2.8,3.3,3.9,6.9,2.1,8.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    className: "cls-4",
    d: "M13.2,16.2c2.3,0,3.8-3.5,3.8-7.8S13.2.7,13.2.7c0,0-3.8,3.5-3.8,7.8s1.5,7.8,3.8,7.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    className: "cls-6",
    d: "M11.9,15.7c1.8,1.5,5.2-.2,7.9-3.5,2.8-3.3,2.1-8.4,2.1-8.4,0,0-5.2.2-7.9,3.5-2.8,3.3-3.9,6.9-2.1,8.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    className: "cls-8",
    d: "M9.4,8.4c0-1,.2-2.1.6-3,.9.5,1.7,1.1,2.3,1.9,2.8,3.3,3.9,6.9,2.1,8.4-.4.3-.9.5-1.4.5-2.2-.1-3.7-3.5-3.7-7.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    className: "cls-3",
    d: "M17,8.4c0-1-.2-2.1-.6-3-.9.5-1.7,1.1-2.4,1.9-2.8,3.3-3.9,6.9-2.1,8.4.4.3.9.5,1.4.5,2.2-.1,3.7-3.5,3.7-7.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    className: "cls-2",
    d: "M13.2,19.5l-1.6-4.2c-1.1-1.4-.4-4.2,1.6-6.9,2,2.7,2.7,5.5,1.6,6.9l-1.6,4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    className: "cls-5",
    d: "M13.2,19.7c0-2.5,1.6-5.4,4.5-7.4,2.9-2,6.2-2.5,8.5-1.6-2.7.4-5.3,1.4-7.5,3-2.3,1.5-4.2,3.6-5.5,6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    className: "cls-7",
    d: "M13.2,19.7c0-2.5-1.6-5.4-4.5-7.4S2.5,9.7.2,10.7c2.7.4,5.3,1.4,7.5,3,2.3,1.5,4.2,3.6,5.5,6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalZakaut);
export default __webpack_public_path__ + "static/media/salZakaut.9b1336e3e627f358feb91b6fc3afe3c3.svg";
export { ForwardRef as ReactComponent };